import du from '../utils/dom-utilities';

/**
 * Display a "back to top" button in the interface right margin.
 *
 * @param  {Null}
 * @return {Set|Listenner} - Set classes onscroll to show or hide the "buttonBackToTop" HTMLElement.
 */
export default function init() {
    const buttonBackToTop = document.querySelector('.button-backtotop.js-back-to-top');

    if (!du.isElement(buttonBackToTop)) {
        console.error(
            '"buttonBackToTop" must be a valid HTMLElement'
        );

        return;
    }

    const headerBannerHeight = document.querySelector('header[role="banner"]').getBoundingClientRect().height;
    const visible = 'state--visible';
    const watermark = 'state--visible--watermark';
    const hidden = 'state--hidden';


    du.onEvent(window, 'optimized-scroll', du.setThrottle(() => {
        let scrollTopPosition = document.body.scrollTop || document.documentElement.scrollTop;
        let scrollCue =  scrollTopPosition >= (headerBannerHeight / 1.5);

        if (scrollCue) {
            du.setClass(buttonBackToTop, visible);

            du.unsetClass(buttonBackToTop, hidden);
            du.unsetClass(buttonBackToTop, watermark);

            if (scrollTopPosition >= (headerBannerHeight * 1.5)) {
                du.setClass(buttonBackToTop, watermark);

                du.unsetClass(buttonBackToTop, visible);
            }
        }

        if (!scrollCue) {
            du.setClass(buttonBackToTop, hidden);

            du.unsetClass(buttonBackToTop, visible);
            du.unsetClass(buttonBackToTop, watermark);
        }

    }, 500));
};



// WEBPACK FOOTER //
// ./src/main/js/components/button-backtotop.js